import { Tooltip } from "../../../../../components/Tooltip/Tooltip";
import { AttendeeResponseBadgeProps } from "../utils/types";
import { ATTENDEE_RESPONSE_BADGE_CONFIG } from "../utils/constants";

const AttendeeResponseBadge = ({
  response,
  className = "",
}: AttendeeResponseBadgeProps) => {
  if (!response) return null;
  const config = ATTENDEE_RESPONSE_BADGE_CONFIG?.[response];
  if (!config) return null;

  return (
    <Tooltip
      content="User's Response"
      side="bottom"
      sideOffset={1}
      contentClassName="text-sm !px-2 !py-1"
    >
      <span
        className={`inline-flex items-center px-3 py-px rounded-[4px] text-md font-medium whitespace-nowrap ${config?.bgClass} ${config?.textClass} ${className}`}
      >
        {config?.label}
      </span>
    </Tooltip>
  );
};

export default AttendeeResponseBadge;
